import React from "react";
import classNames from "classnames";
import { FormattedMessage, useIntl } from "react-intl";

export default function OrderingInfo(props) {
  const {
    editable,
    delivery,
    allow_ordering_before_suggestions_at,
    delivery_smartfill_state,
    delivery_suggestion_state,
    days_until_ordering_window_opens,
    empty,
    remaining_time,
    nextEditableCart,
    companyEmail,
    companyName,
    ownerlessShop,
    showOnboardingPopup,
  } = props;
  const intl = useIntl();

  let days_until_ordering_window_opens_str = "";
  if (days_until_ordering_window_opens) {
    days_until_ordering_window_opens_str =
      "days" in days_until_ordering_window_opens
        ? intl.formatMessage(
            { id: "remainingTimeDays" },
            { remaining_time: days_until_ordering_window_opens["days"] },
          )
        : "hours" in days_until_ordering_window_opens
        ? intl.formatMessage(
            { id: "remainingTimeHours" },
            { remaining_time: days_until_ordering_window_opens["hours"] },
          )
        : "";
  }

  let remaining_str = "";
  if (remaining_time) {
    remaining_str =
      "days" in remaining_time
        ? intl.formatMessage(
            { id: "remainingTimeDays" },
            { remaining_time: remaining_time["days"] },
          )
        : "hours" in remaining_time
        ? intl.formatMessage(
            { id: "remainingTimeHours" },
            { remaining_time: remaining_time["hours"] },
          )
        : "";
  }

  const ordering_is_open_in_window = editable &&
    delivery &&
    remaining_str &&
    !delivery.sold_and_edited &&
    (!days_until_ordering_window_opens_str ||
      (delivery_smartfill_state == "no-rules" &&
        allow_ordering_before_suggestions_at)) && (
      <div>
        <p>
          <FormattedMessage id="openOrderWindow" />
        </p>
        <p>
          ... <FormattedMessage id="closes" /> {remaining_str}
        </p>
      </div>
    );
  const force_editable_after_ordering_window = editable &&
    delivery &&
    !remaining_str && (
      <div>
        <p>
          <FormattedMessage id="orderingWindowExtended" />
        </p>
        <p>
          <FormattedMessage id="oneTimeOrder" />
        </p>
      </div>
    );
  const past_editable = !editable ? (
    <div>
      <FormattedMessage
        id="expiredDeadlineMsg"
        values={{ strong: (chunks) => <strong>{chunks}</strong> }}
      />
    </div>
  ) : (
    ""
  );
  const paused_or_cancelled_cart_message = delivery?.sold &&
    editable &&
    empty && (
      <div>
        {delivery.sold_and_edited && (
          <p>
            <FormattedMessage id="youCanCancelCart" />
          </p>
        )}
        {!delivery.sold_and_edited &&
          delivery_smartfill_state == "auto-buy" && (
            <p>
              <FormattedMessage id="deliveryIsPaused" />
            </p>
          )}
        {!delivery.sold_and_edited &&
          delivery_smartfill_state != "auto-buy" && (
            <p>
              <FormattedMessage id="cartCancelled" />
            </p>
          )}
        {editable && !delivery.sold_and_edited && (
          <p>
            <FormattedMessage id="changeMind" />
          </p>
        )}
      </div>
    );
  const ordering_not_open_yet = !allow_ordering_before_suggestions_at ? (
    <div>
      <p>
        <FormattedMessage
          id="orderWindowOpens"
          values={{
            strong: (chunks) => <strong>{chunks}</strong>,
            days_until_ordering_window_opens_str:
              days_until_ordering_window_opens_str,
          }}
        />
      </p>
      {delivery_suggestion_state == "notifications-on" &&
        delivery_smartfill_state != "auto-buy" &&
        !delivery.sold && (
          <p>
            {" "}
            <FormattedMessage id="reminderByEmail" />{" "}
          </p>
        )}
      {delivery_suggestion_state == "notifications-off" &&
        delivery_smartfill_state != "auto-buy" &&
        !delivery.sold && (
          <p>
            <FormattedMessage id="activateReminder" />
          </p>
          // tood: change this info to a button that turns on notifications called 'inform me'
        )}
      {delivery_smartfill_state == "auto-buy" && !delivery.sold && (
        <p>
          <FormattedMessage
            id="clickPause"
            values={{ strong: (chunks) => <strong>{chunks}</strong> }}
          />
        </p>
      )}
    </div>
  ) : (
    ""
  );
  const cart_will_be_autofilled =
    allow_ordering_before_suggestions_at &&
    days_until_ordering_window_opens_str ? (
      <div>
        {delivery_smartfill_state == "auto-buy" && !delivery.sold && (
          <p>
            <FormattedMessage
              id="cartWithSubscribeRules"
              values={{
                strong: (chunks) => <strong>{chunks}</strong>,
                days_until_ordering_window_opens_str:
                  days_until_ordering_window_opens_str,
              }}
            />
          </p>
        )}
        {delivery_smartfill_state == "has-propose-rules" && !delivery.sold && (
          <p>
            <FormattedMessage
              id="cartWithProposalRules"
              values={{
                strong: (chunks) => <strong>{chunks}</strong>,
                days_until_ordering_window_opens_str:
                  days_until_ordering_window_opens_str,
              }}
            />
          </p>
        )}
        {["has-propose-rules", "auto-buy"].includes(delivery_smartfill_state) &&
          !delivery.sold && (
            <p>
              <FormattedMessage id="unlessYouOrderManually" />
            </p>
          )}
      </div>
    ) : (
      ""
    );
  const button_to_next_cart_or_contact = !editable ? (
    nextEditableCart ? (
      <a className="button next-cart-button" href={nextEditableCart}>
        <FormattedMessage id="newOrder" />
      </a>
    ) : (
      <a
        target="_blank"
        className="button next-cart-button"
        href={"mailto:" + companyEmail}
      >
        <FormattedMessage
          id="contactNewOrder"
          values={{ companyEmail: companyEmail }}
        />
      </a>
    )
  ) : (
    ""
  );

  const className =
    (!days_until_ordering_window_opens_str && !editable) ||
    !allow_ordering_before_suggestions_at
      ? "red-border"
      : "";

  return (
    <>
      {ownerlessShop ? (
        <div className="empty-cart-display">
          <p className="welcome-text">
            <FormattedMessage
              id="welcomeInShop"
              values={{ companyName: companyName }}
            />
          </p>
          <a className="button next-cart-button" onClick={showOnboardingPopup}>
            <FormattedMessage id="viewOrderingWindow" />
          </a>
        </div>
      ) : (
        (empty || !editable) && (
          <div className={classNames("empty-cart-display", className)}>
            <div>
              {paused_or_cancelled_cart_message}
              {ordering_not_open_yet}
              {cart_will_be_autofilled}
              {past_editable}
              {ordering_is_open_in_window}
              {force_editable_after_ordering_window}
            </div>
            {button_to_next_cart_or_contact}
          </div>
        )
      )}
    </>
  );
}
